import { render, staticRenderFns } from "./FieldBtn.vue?vue&type=template&id=2080f839&scoped=true&"
import script from "./FieldBtn.vue?vue&type=script&lang=js&"
export * from "./FieldBtn.vue?vue&type=script&lang=js&"
import style0 from "./FieldBtn.vue?vue&type=style&index=0&id=2080f839&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2080f839",
  null
  
)

export default component.exports